/*
 * `ListViewItem` makes its rows look clickable; here only the actions inside them are,
 * so the cursor is reset. The element selector keeps this ahead of the row's own styles.
 */
tr.row {
  cursor: default;
}

.avatarCell,
.actionCell {
  width: 1%;
}

.actionCell {
  text-align: right;
}
